import * as React from 'react';
import { Row } from 'react-bootstrap';
import { formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow, toUpper } from 'lodash';
import { connect } from 'react-redux';
import ResetPasswordForm from './components/ResetPasswordForm';
import { actions as authActions } from '../../../../services/auth/reducer';
import { IStore } from '../../../../redux/IStore';
import { IAuthActions } from '../../../../services/auth/models';

interface IAuthError {
  detail: string;
}

interface IResetPasswordProps {
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  title: string;
  message: string;
  auth: {
    error: {
      reset: {
        error: IAuthError,
      },
      update: {
        error: IAuthError,
      },
    },
  };
  match: {
    params: {
      token: string,
    },
  };
}

interface IResetPasswordState {
  hasPasswordBeenReset: boolean;
}

class ResetPassword extends React.Component<IResetPasswordProps, IResetPasswordState> {
  public state = {
    hasPasswordBeenReset: false,
  };

  private handleSubmit = (values) => {
    const { actions, match } = this.props;
    const token = match.params.token;
    actions.auth.resetPassword(token, values);
  }

  public render() {
    const { title} = this.props;

    return (
      <Row className="page-container">
        <div className="customer-section-title">
          <h1>{title ? title : 'Reset Password'}</h1>
        </div>
        <ResetPasswordForm onSubmit={this.handleSubmit} buttonText={toUpper(title)}/>
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'reset_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('reset_password');

    return component;
  },
  connect(
    (state: IStore) => ({
      auth: state.auth,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(ResetPassword);
